import { Mui, omitReduxProps } from "@osu/react-ui";
import { Link as RouterLink, useLocation } from "react-router-dom";
import { STATUSES } from "../../util/constants";
import { useSelector } from "react-redux";
import { selectAuthenticationStatus } from "../../services/authorization/slices";
import { useState } from "react";
import { authorizationRoutes } from "../../Routes/paths";
import InternalLink from "./Link";
import { mergeSxStyles } from "../../styles/util";

function AuthButton(props = {}) {
  const { name, ...rest } = props;
  let remainingProps = omitReduxProps(rest);
  const status = useSelector(selectAuthenticationStatus)
  const [inOrOut, setInOrOut] = useState("In")
  const { pathname } = useLocation()
  const onAuthPage = [authorizationRoutes.login, authorizationRoutes.unauthorized].includes(pathname)

  if(onAuthPage) {
    return false
  }

  if (status === STATUSES.LOADING) {
    return (
        <Mui.Box {...remainingProps} sx={{display: "flex", flexDirection: "row", alignItems: 'center'}}>
          <Mui.CircularProgress size="1.4em" className="margin-right-1"/>
          <Mui.Typography variant="body2" sx={{
            fontStyle: 'italic'
          }}>
            {Boolean(inOrOut) && `Signing ${inOrOut}`}
          </Mui.Typography>
        </Mui.Box>
    );
  }

  remainingProps.sx = mergeSxStyles(remainingProps.sx ?? {}, (theme) => theme.typography.subtitle2)
  if (status === STATUSES.SUCCESS) {
    return (
      <InternalLink  onClick={() => setInOrOut("Out")} color="secondary" component={RouterLink} to="/logout" {...remainingProps}>
        Sign Out
      </InternalLink>
    );
  }

  return (
    <Mui.Button 
      size="small"
      color="primary" 
      variant="outlined" 
      onClick={() => setInOrOut("In")} 
      component={RouterLink} 
      to="/login" 
      {...remainingProps}
      sx={mergeSxStyles(remainingProps.sx ?? {}, {
        textTransform: 'none'
      })}>
      Sign In
    </Mui.Button>
  );
}

export default AuthButton;